import styled from 'styled-components'

export const SvgWithRotation = styled.svg`
  ${({ rotation = 0 }) => `transform: rotateZ(${rotation}deg);`}
`
